import { axiosInstance } from "@helpers/axios-instance";
import { useQuery } from "@tanstack/react-query";
import { EnumItem } from "@/types/types";

export function useDictionaryTypes() {
  return useQuery({
    queryKey: ["dictTypes"],
    queryFn: async () => {
      const { data } = await axiosInstance({
        method: "GET",
        url:  `Dictionary/DictionaryTypes`,
      });

      return data?.data as Array<EnumItem>;
    },
  });
}
